// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"largeQuote-module--wrapper--UWIIb","quote":"largeQuote-module--quote--1jc2I","fontsLoading":"largeQuote-module--fonts-loading--1XLva"};